import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/teacher/teacherResourceSort"

const teacherResourceSort = {
  resourceSortListPage(pageSize, limit, versionId, keyWord) {
    return axios.get(pre + `/resourceSortListPage`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          versionId: versionId,
          keyWord: keyWord
        }
    });
  },
  resourceSortList() {
    return axios.get(pre + `/resourceSortList`);
  },
  resourceSortInfo(id) {
    return axios.get(pre + `/resourceSortInfo`, {params: {id: id}});
  },
  resourceSortSave(params) {
    return axios.post(pre + `/resourceSortSave`, qs.stringify(params));
  },
  resourceSortDelete(id) {
    return axios.delete(pre + `/resourceSortDelete`, {params: {id: id}});
  },
}
export default teacherResourceSort;



// WEBPACK FOOTER //
// ./src/api/teacher/teacherResourceSort.js